import React from "react";
import { useLocation } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import ChatBot from "./chat-bot";

const ChatBotContainer = () => {
  const location = useLocation();
  const { currentUser } = useAuth();
  const onboardingComplete = Boolean(currentUser?.profile?.onboardingComplete);

  const hideChatPaths = [
    "/",
    "/signin",
    "/signup",
    "/forgot-password",
    "/reset-password",
    "/otp-verify",
    "/onboarding",
    "/verify-account",
    "/verify",
    "/talk-to-sales",
    "/booking/confirmed",
  ];

  const showChat =
    onboardingComplete && !hideChatPaths.includes(location.pathname);

  // Use size="sm" to keep it compact; you can change to "md" or "lg"
  return <ChatBot isVisible={showChat} size="sm" />;
};

export default ChatBotContainer;